export default __webpack_public_path__ + "static/media/info-circle.b761daa2.svg";